"use client";

import {useRouter, useSearchParams} from "next/navigation";
import {Button} from "@/components/ui/button";
import {useSignals} from "@preact/signals-react/runtime";
import {Suspense, useEffect} from "react";
import {CheckCircle2, Tickets, X} from "lucide-react";
import {loadPaymentSuccessData, paymentSuccessData,} from "@/app/payment-success/store/payment-success.store";
import {Loader} from "@/components/ui/loader";
import {formatedDateTimeOffsetUtc} from "@/lib/date-time-utils";
import Link from "next/link";

const PaymentOrderDetails = () => {
    useSignals();
    const searchParams = useSearchParams();
    useEffect(() => {
        const paymentIntent = searchParams?.get("payment_intent") ?? '';
        const paymentRecordId = searchParams?.get("paymentRecordId") ?? '';
        loadPaymentSuccessData(paymentIntent, paymentRecordId);
    }, []);


    const event = paymentSuccessData?.value?.event;

    return (
        <>
            {paymentSuccessData.value && (
                <div className="flex flex-col px-3 py-0 md:p-8">
                    <div className="flex items-center gap-1">
                        <Tickets
                            size={24}
                            strokeWidth={2}
                            className="stroke-stone-neutral-12"
                        />
                        <p className="m-0 text-lg font-bold text-stone-neutral-12">
                            Your order
                        </p>
                    </div>
                    <div className="flex flex-col flex-1 mt-4">
                        {paymentSuccessData.value.items.map((item, index) => {
                            return (
                                <>
                                    <div
                                        key={index}
                                        className="flex justify-between items-center w-full py-3 gap-3 border-b border-stone-neutral-5 last:!border-b-0">
                                        <div className="flex flex-col flex-1">
                                            <div className="text-base text-stone-neutral-12">
                                                {item.title}
                                            </div>
                                        </div>
                                        <div className="flex items-center">
                                            <X size={16}/>
                                            <p className="text-base text-stone-neutral-12">
                                                {item.quantity}
                                            </p>
                                        </div>
                                        {/* TODO: get ticket price here  */}
                                        <div>
                                            <p className="text-base text-stone-neutral-12">{event?.organization.organizationCurrency} {item.price}</p>
                                        </div>
                                    </div>
                                </>
                            );
                        })}
                    </div>
                    {/* TODO: Price calculation section  */}
                    {/* <div className="border-y border-stone-neutral-5 py-3">
                        <div className="flex justify-between">
                            <p className="text-base text-stone-neutral-12">Sub total</p>
                            <p className="text-base text-stone-neutral-12">$500.00</p>
                        </div>
                        <div className="flex justify-between">
                            <p className="text-base text-stone-neutral-12">Service charge</p>
                            <p className="text-base text-stone-neutral-12">$100.00</p>
                        </div>
                    </div>
                    <div className="py-2">
                        <div className="flex justify-between">
                            <p className="text-base font-bold text-stone-neutral-12">Total</p>
                            <p className="text-base font-bold text-stone-neutral-12">
                                $600.00
                            </p>
                        </div>
                    </div>*/}
                </div>
            )}
        </>
    );
};

const PaymentSuccessPage = () => {
    useSignals();

    const router = useRouter();

    const handleRedirect = () => {
        router.push("/");
    };

    const event = paymentSuccessData?.value?.event;
    return (
        <div className="flex flex-col mx-auto my-8 max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 !gap-0">
                <div className="flex flex-col space-y-6 px-3 py-0 md:p-8 border-r-1 border-">
                    <div className="flex flex-col gap-1 sm:gap-0">
                        <div className="flex items-center gap-2">
                            <CheckCircle2
                                size={24}
                                strokeWidth={2}
                                className="stroke-forest-green-9"
                            />
                            <h1 className="text-lg font-bold text-forest-green-11">
                                Ticket purchase successful
                            </h1>
                        </div>
                        <p className="text-base text-stone-neutral-12">
                            Thank you for your payment. This transaction is now completed
                        </p>
                    </div>
                    {/* Event details  */}
                    {/* TODO: Bind data here  */}
                    <div
                        className="flex flex-col md:flex-row bg-stone-neutral-0 border border-stone-neutral-5 p-3 rounded-lg gap-3">
                        <div className="w-full md:w-[140px] h-[240px] md:h-full overflow-hidden rounded-md">
                            <img className="w-full h-full object-cover"
                                 src={event?.image} alt="Event cover"/>
                        </div>
                        <div className="flex flex-col gap-2">
                            <p className="m-0 text-lg font-bold text-stone-neutral-12">
                                {event?.name}
                            </p>
                            <div className="flex flex-col gap-1">
                                <p className="text-sm text-stone-neutral-11">Date</p>
                                <p className="text-base font-bold text-stone-neutral-12">
                                    {formatedDateTimeOffsetUtc(event?.startTimeStamp, event?.location.timeZone)}
                                </p>
                            </div>
                            <div className="flex flex-col gap-1">
                                <p className="text-sm text-stone-neutral-11">Venue</p>
                                <p className="text-base font-bold text-stone-neutral-12">
                                    {event?.location.name},
                                    <div>
                                        {event?.location.address}
                                    </div>
                                </p>
                            </div>
                        </div>
                    </div>
                    <p className="text-base text-stone-neutral-12">
                        A confirmation email has been sent to your registered email.
                    </p>
                    <div className="flex items-center gap-0 text-base font-bold text-stone-neutral-12">
                        <p className="m-0">Need help?</p>
                        <Link href={`/organization/${event?.organization.id}`}>
                            <Button variant="link" className="text-base font-bold">
                                Contact us
                            </Button>
                        </Link>

                    </div>
                    <div className="flex gap-2">
                        {/* TODO: navigate to event page  */}
                        <Button className="w-full md:w-auto" onClick={handleRedirect}>
                            Looks for more events
                        </Button>
                        <Button
                            className="w-full md:w-auto"
                            variant="outline"
                            onClick={() => {
                                router.push("/my-tickets");
                            }}
                        >
                            View my tickets
                        </Button>
                    </div>
                </div>
                <div className="mt-6 pt-6 md:pt-0 md:mt-0 border-t md:border-t-0 md:border-l border-stone-neutral-5">
                    <Suspense fallback={<Loader/>}>
                        <PaymentOrderDetails/>
                    </Suspense>
                </div>
            </div>
        </div>
    );
};

export default PaymentSuccessPage;
